import { jsx as _jsx } from "react/jsx-runtime";
// SkeletonShimmer — premium variant of Skeleton that uses a moving gradient.
// Additive: does NOT replace ./Skeleton.tsx (kept for tests and existing callers).
// Bundle cost: ~170 B.
// Accessibility: role="status" + aria-busy + aria-label, identical to Skeleton.
export function SkeletonShimmer({ className = '' }) {
    return (_jsx("div", { role: "status", "aria-busy": "true", "aria-label": "Loading", className: `rr-shimmer rounded-md ${className}` }));
}
export function SkeletonShimmerText({ lines = 3 }) {
    return (_jsx("div", { className: "mt-3 space-y-2", children: Array.from({ length: lines }).map((_, i) => (_jsx(SkeletonShimmer, { className: `h-3 ${i === lines - 1 ? 'w-4/6' : 'w-full'}` }, i))) }));
}
